import { InjectionToken } from '@angular/core';

import type { DoodOrderModel } from '@store/order/order.model';

/** Runtime VM emitted by `OrdersPageBlock` data sources. */
export type OrdersPageBlockViewModel = {
  activeOrders: readonly DoodOrderModel[];
  historicalOrders: readonly DoodOrderModel[];
  isActiveOrdersLoading: boolean;
  isHistoricalOrdersLoading: boolean;
};

export const ORDERS_PAGE_BLOCK_LOADING_VM: OrdersPageBlockViewModel = {
  activeOrders: [],
  historicalOrders: [],
  isActiveOrdersLoading: true,
  isHistoricalOrdersLoading: true,
};

export const ORDERS_PAGE_BLOCK_EMPTY_VM: OrdersPageBlockViewModel = {
  activeOrders: [],
  historicalOrders: [],
  isActiveOrdersLoading: false,
  isHistoricalOrdersLoading: false,
};

export interface OrdersPageBlockDataSource {
  readonly vm$: import('rxjs').Observable<OrdersPageBlockViewModel>;
}

export const ORDERS_PAGE_BLOCK_DATA_SOURCE = new InjectionToken<OrdersPageBlockDataSource>(
  'ORDERS_PAGE_BLOCK_DATA_SOURCE',
);
